/**
 * The one close cross every closeable window, page and popup wears.
 *
 * A bright cross and NOTHING else: no square border, no chip, no background.
 * The cross is drawn with two bars (::before / ::after) rather than a text
 * glyph so it is crisp and identical in every font and on every platform, and
 * a dark drop-shadow outlines it so it survives any textured plate. The hit
 * area is the 44px button itself; the cross is only 30px of it.
 *
 * Markup comes from `close-button.ts` (createCloseButton / closeButtonHtml).
 * A window may add its own class beside bv-close for hooks and for placing the
 * cross in its corner; it must not restyle the look.
 *
 * NO BACKTICKS anywhere in this file, comments included: the export is one
 * template literal and a stray backtick terminates it.
 */
export default `
.bv-close {
  position: absolute;
  top: 4px; right: max(4px, env(safe-area-inset-right));
  z-index: 6;
  display: flex; align-items: center; justify-content: center;
  box-sizing: border-box;
  width: 44px; height: 44px; min-width: 44px; min-height: 44px;
  margin: 0; padding: 0;
  background: none; border: 0; border-radius: 8px;
  color: #ffeec4;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  filter: drop-shadow(0 0 1px #000) drop-shadow(0 1px 2px rgba(0,0,0,0.9));
  transition: color 0.14s ease, transform 0.14s ease, filter 0.14s ease;
}
.bv-close::before, .bv-close::after {
  content: "";
  position: absolute; left: 50%; top: 50%;
  width: 30px; height: 4px; border-radius: 2px;
  background: currentColor;
}
.bv-close::before { transform: translate(-50%, -50%) rotate(45deg); }
.bv-close::after { transform: translate(-50%, -50%) rotate(-45deg); }
.bv-close:hover {
  color: #fff;
  filter: drop-shadow(0 0 1px #000) drop-shadow(0 1px 2px rgba(0,0,0,0.9)) drop-shadow(0 0 6px rgba(255,214,120,0.7));
}
.bv-close:focus-visible { color: #fff; outline: 2px solid #ffe39a; outline-offset: 0; }
.bv-close:active { transform: scale(0.88); }
/* In a flow header (chat, survivor record): the 44px hit area overlaps the
   header padding instead of growing the bar. */
.bv-close.bv-close-inline {
  position: relative; top: auto; right: auto; z-index: auto;
  flex: none; margin: -12px -8px -12px 0;
}
@media (prefers-reduced-motion: reduce) {
  .bv-close { transition: none; }
  .bv-close:active { transform: none; }
}
`;
